module.exports = __webpack_public_path__ + "img/account_inner.3f8377af.svg";